import React, { useState } from 'react';
import { BarChart3, ListChecks } from 'lucide-react';
import FolderTabLayout from './ui/folder-tab-layout';
import DriverSummarySimple from './DriverSummarySimple';
import JobByJobSummary from './JobByJobSummary';

interface DriverSummaryProps {
  driverName: string;
  startDate: string;
  endDate: string;
}

const DriverSummary: React.FC<DriverSummaryProps> = ({ driverName, startDate, endDate }) => {
  const [tab, setTab] = useState<'summary' | 'jobs'>('summary');

  return (
    <FolderTabLayout
      tabs={[
        { value: 'summary', label: 'Payment Summary', icon: BarChart3 },
        { value: 'jobs', label: 'Job by Job', icon: ListChecks },
      ]}
      value={tab}
      onValueChange={(v) => setTab(v as typeof tab)}
    >
      {tab === 'summary' && (
        <DriverSummarySimple
          driverName={driverName}
          startDate={startDate}
          endDate={endDate}
        />
      )}

      {tab === 'jobs' && (
        <JobByJobSummary
          driverName={driverName}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </FolderTabLayout>
  );
};

export default DriverSummary;
